import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import "../pago-deducible.css";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import ModalError from "../modal-error/modal-error.cmpt";
import InsertDriveFileOutlinedIcon from "@material-ui/icons/InsertDriveFileOutlined";
import GetAppOutlinedIcon from "@material-ui/icons/GetAppOutlined";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputBase from "@material-ui/core/InputBase";
import * as action from "../pagoDeducibleAuto-actions";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import { Card, Grid } from "@material-ui/core";

const cadenaVacia = "";
const sinSolicitud = "Sin Solicitud";
const espacio = " ";

const BootstrapInput = withStyles((theme) => ({
	root: {
		"label + &": {
			marginTop: theme.spacing(3),
		},
		"& .MuiSelect-select:focus": {
			backgroundColor: "#FFFFFF",
		},
	},
	input: {
		color: "#33445F",
		width: "110px",
		borderRadius: 4,
		position: "relative",
		backgroundColor: theme.palette.background.paper,
		fontSize: 16,
		padding: "10px 26px 10px 12px",
		transition: theme.transitions.create(["border-color", "box-shadow"]),
		fontFamily: [
			"-apple-system",
			"BlinkMacSystemFont",
			"\"Segoe UI\"",
			"Roboto",
			"\"Helvetica Neue\"",
			"Arial",
			"sans-serif",
			"\"Apple Color Emoji\"",
			"\"Segoe UI Emoji\"",
			"\"Segoe UI Symbol\"",
		].join(","),
	},
}))(InputBase);

const useStyles = makeStyles((theme) => ({
	root: {
		width: "100%",
		border: "1px solid #CED8E8",
		boxShadow: "none",
		color: "#33445F",
		fontSize: "16px",
	},
	container: {
		maxHeight: 440,
	},
	headerTable: {
		backgroundColor: "#F6F9FD",
		color: "#002E71",
		fontSize: "12px",
		fontWeight: "normal",
		lineHeight: "16px",
	},
	paperBusqueda: {
		padding: "2px 4px",
		display: "flex",
		alignItems: "center",
		width: "100%",
		marginBottom: "20px",
	},
	input: {
		marginLeft: theme.spacing(1),
		flex: 1,
		fontSize: "16px",
		color: "#647085",
	},
	iconButton: {
		padding: 10,
		"& .MuiTouchRipple-root": {
			color: "#FF6B0B",
		},
	},
	divider: {
		height: 28,
		margin: 4,
	},
	styleCelda: {
		fontSize: "14px",
		color: "#33445F",
	},
	contentModalRecibos: {
		height: "348px",
	},
	margingIcon: {
		marginBottom: "-4px",
		marginRight: "10px",
		width: "18px",
		height: "18px",
	},
	footerModalRecibos: {
		justifyContent: "flex-start",
		paddingBottom: "40px",
		paddingLeft: "42px",
	},
	colorIconSize: {
		width: "24px",
		height: "24px",
		color: "#FF6B0B",
	},
	cardResponsive: {
		padding: "16px 0px 20px 16px",
		background: "#FEFEFE",
		boxShadow: "0px 2px 4px #ECF1F8, 0px 3px 4px #ECF1F8, 0px 1px 5px #ECF1F8",
		borderRadius: "4px",
	},
	menuResponsive: {
		background: "#FEFEFE",
		boxShadow: "0px 2px 4px #ECF1F8, 0px 3px 4px #ECF1F8, 0px 1px 5px #ECF1F8",
		borderRadius: "4px",
	},
	paperModalRecibos: {
		"& .MuiDialog-paperScrollPaper": {
			maxHeight: "348px",
		},
		"& .MuiDialog-paper": {
			width: "744px",
			overflow: "hidden",
		},
	},
}));

const colorEstatus = (estatus) => {
	let color;
	switch (estatus) {
	case "En Proceso":
		color = "#FFA14A";
		break;
	case sinSolicitud:
		color = "red";
		break;
	case "Emitido":
		color = "#5BC790";
		break;
	default:
		color = cadenaVacia;
		break;
	}
	return color;
};

function myFunction(e, key) {
	document.getElementById(`drop${key}`).classList.toggle("show");
}

const validCurrentPage = (currentPage) => {
	let arrorIsDisabled = cadenaVacia;
	if (currentPage < 1) {
		arrorIsDisabled = "arrow-disabled";
	}
	return arrorIsDisabled;
};

const validValue = (value, callback) => {
	if (value && value !== cadenaVacia) {
		return value;
	} else {
		return callback;
	}
};

const validExistArchivos = (element) => {
	return(
		(element.archivoPDF && element.archivoPDF !== cadenaVacia) ||
    (element.archivoXML  && element.archivoXML !== cadenaVacia) ||
    (element.pdfComprobante && element.pdfComprobante !== cadenaVacia)
	);
};

const handleDescargaTipoArchivo = (tipo, nameFile, base64, setArchivoVacio) => {
	if (base64 !== cadenaVacia) {
		const linkSource = `data:application/${tipo};base64,${base64}`;
		const downloadLink = document.createElement("a");
		const fileName = nameFile;

		downloadLink.href = linkSource;
		downloadLink.download = fileName;
		downloadLink.click();
	} else if (base64 === cadenaVacia || !base64) {
		setArchivoVacio(true);
	}
};

const handleDescargaArchivos = (descargaRecibos, setArchivoVacio) => {
	if (descargaRecibos.archivoPDF !== cadenaVacia) {
		handleDescargaTipoArchivo(
			"pdf",
			"ComprobanteFiscal.pdf",
			descargaRecibos.archivoPDF,
			setArchivoVacio
		);
	}
	if (descargaRecibos.archivoXML !== cadenaVacia) {
		handleDescargaTipoArchivo(
			"xml",
			"ComprobanteFiscal.xml",
			descargaRecibos.archivoXML,
			setArchivoVacio
		);
	}
	if (descargaRecibos.pdfComprobante !== cadenaVacia) {
		handleDescargaTipoArchivo(
			"pdf",
			"comprobantePago.pdf",
			descargaRecibos.pdfComprobante,
			setArchivoVacio
		);
	}
};

const validWindowSize = (setViewResponsive) => {
	if (window.innerWidth <= 1055) {
		setViewResponsive({
			responsive: true,
		});
	}
};

const handleChangeInput = (
	event,
	listaCfdi,
	paginator,
	setListaFiltro,
	setBusquedaInputParam,
	setPaginator
) => {
	event.stopPropagation();
	event.target.pattern = "[0-9]{0,14}";
	const esValido = event.target.validity.valid;
	if (event.target.value === cadenaVacia) {
		setListaFiltro([...listaCfdi]);
		setBusquedaInputParam(event.target.value);
		setPaginator({
			...paginator,
			currentPage: 0,
			numRegistros: 5,
			noHided: 0,
		});
	} else if (esValido) {
		setBusquedaInputParam(event.target.value);
	}
};

const setRecibosDescarga = (item, descargaRecibos, setDescargaRecibos) => {
	setDescargaRecibos({
		...descargaRecibos,
		archivoPDF: validValue(item.archivoPDF, cadenaVacia),
		archivoXML: validValue(item.archivoXML, cadenaVacia),
		pdfComprobante: validValue(item.pdfComprobante, cadenaVacia),
	});
};

const validRespDatosFiscales = (response) => {
	let validResp = false;
	if (response.data && Object.entries(response.data).length > 0) {
		if (
			response.data.datosFiscales &&
      Object.entries(response.data.datosFiscales).length > 0
		) {
			validResp = true;
		}
	}
	return validResp;
};

const numUltRegistro = (paginator) => {
	console.log("paginator en numRe",paginator);
	return (
		paginator.currentPage * paginator.numRegistros + paginator.numRegistros
	);
};

const getNumRegistro = (listaFiltroLength, paginator) => {
	let numRegistro = numUltRegistro(paginator);
	if (numRegistro > listaFiltroLength) {
		numRegistro = listaFiltroLength;
	}
	return numRegistro;
};

const validCurrentPageByFiltro = (listaFiltroLength, paginator) => {
	let arrorIsDisabled = cadenaVacia;
	if (numUltRegistro(paginator) >= listaFiltroLength) {
		arrorIsDisabled = "arrow-disabled";
	}
	return arrorIsDisabled;
};

const goToPage = (i, paginator, listaFiltro, setPaginator) => {
	if (i < 0 || i * paginator.numRegistros >= listaFiltro.length){
		return true;
	} else {
		setPaginator({...paginator, noHided: 0, currentPage: i,});
		return false;
	}
};

const showLinkDescarga = (
	archivoBase64,
	setArchivoVacio,
	ext,
	nombreArchivo,
	margingIcon,
	textLink
) => {
	if (archivoBase64 !== cadenaVacia) {
		return (
			<p className="marginLinkRecibos">
				<button
					className="buttonIconRecibos"
					onClick={() =>
						handleDescargaTipoArchivo(
							ext,
							nombreArchivo,
							archivoBase64,
							setArchivoVacio
						)
					}
				>
					<a className="hooverLinkRecibos">
						<InsertDriveFileOutlinedIcon
							className={margingIcon}
						></InsertDriveFileOutlinedIcon>
						{textLink}
					</a>
				</button>
			</p>
		);
	} else {
		return <span></span>;
	}
};

const modalErrorPrueba = (openModalErrorG, handlePrueba) => {
	if (openModalErrorG) {
		return (
			<ModalError
				openModal={openModalErrorG}
				msjTitle="Servicio no disponible"
				msjBody="Intente nuevamente"
				handleClose={(e) => handlePrueba(e)}
			/>
		);
	} else {
		return <span></span>;
	}
};

const modalArchivoVacio = (archivoVacio, handleCloseArchivoVacio) => {
	if (archivoVacio) {
		return (
			<ModalError
				iconButton={true}
				openModal={archivoVacio}
				msjTitle="Servicio no disponible"
				msjBody="Ha fallado la descarga del archivo"
				handleClose={(e) => handleCloseArchivoVacio(e)}
			/>
		);
	} else {
		return <span></span>;
	}
};

const responsiveAndData = (viewResponsive, listaCfdi) => {
	return !viewResponsive.responsive && listaCfdi.length;
};

const showButtonPagar = (
	item,
	handleSolicitarCfdi,
	colorIconSize
) => {
	if (item.estatusCfdi === sinSolicitud) {
		return (
			<button
				className="hoverAcciones buttonPagar tool-tip-cfdi"
				onClick={(e) => handleSolicitarCfdi(e, item)}
				style={{ borderRadius: "4px 0px 0px 4px" }}
			>
				<a data-tooltip-naranja="Solicitar CFDI">
					<InsertDriveFileOutlinedIcon
						className={colorIconSize}
					></InsertDriveFileOutlinedIcon>
				</a>
			</button>
		);
	} else {
		return <span></span>;
	}
};

const showGridFormBusqueda = (
	data,
	handleChangeSelectParam,
	handleChangeInputEventParam,
	submitBusquedaParam
) => {
	return !data.viewResponsive.responsive && data.listaCfdi.length ? (
		<Grid item xs={12} sm={12} md={4} lg={4}>
			<Paper component="form" className={data.classes.paperBusqueda}>
				<FormControl className={data.classes.margin}>
					<Select
						labelId="demo-customized-select-label"
						id="demo-customized-select"
						value={data.busqueda}
						onChange={handleChangeSelectParam}
						input={<BootstrapInput />}
					>
						<MenuItem className="styleLi" value={"numeroPoliza"}>
              No. Póliza
						</MenuItem>
						<MenuItem className="styleLi" value={"numeroSiniestro"}>
              No. Siniestro
						</MenuItem>
					</Select>
				</FormControl>
				<Divider className={data.classes.divider} orientation="vertical" />
				<InputBase
					value={data.inputBusqueda}
					className={data.classes.input}
					onChange={handleChangeInputEventParam}
					inputProps={{ "aria-label": "search google maps" }}
				/>
				<IconButton
					onClick={submitBusquedaParam}
					className={data.classes.iconButton}
					aria-label="search"
				>
					<SearchIcon />
				</IconButton>
			</Paper>
		</Grid>
	) : (
		data.viewResponsive.responsive && data.listaCfdi.length > 0 && (
			<Grid container spacing={2} item xs={12} sm={12} md={12} lg={12}>
				<Paper component="form" className={data.classes.paperBusqueda}>
					<FormControl className={data.classes.margin}>
						<Select
							labelId="demo-customized-select-label"
							id="demo-customized-select"
							value={data.busqueda}
							onChange={handleChangeSelectParam}
							input={<BootstrapInput />}
						>
							<MenuItem className="styleLi" value={"numeroPoliza"}>
                No. Póliza
							</MenuItem>
							<MenuItem className="styleLi" value={"numeroSiniestro"}>
                No. Siniestro
							</MenuItem>
						</Select>
					</FormControl>
					<Divider className={data.classes.divider} orientation="vertical" />
					<InputBase
						value={data.inputBusqueda}
						className={data.classes.input}
						onChange={handleChangeInputEventParam}
						inputProps={{ "aria-label": "search google maps" }}
					/>
					<IconButton
						onClick={submitBusquedaParam}
						className={data.classes.iconButton}
						aria-label="search"
					>
						<SearchIcon />
					</IconButton>
				</Paper>
			</Grid>
		)
	);
};

const modalDescargaRecibos = (classes, modalRecibos, descargaRecibos, handleCloseModalRecibos, setModalRecibos, setArchivoVacio ) => {
	return <Dialog
		maxWidth={"md"}
		className={classes.paperModalRecibos}
		disableEscapeKeyDown={true}
		disableBackdropClick
		open={modalRecibos.openModalRecibos}
		onClose={handleCloseModalRecibos}
		aria-labelledby="alert-dialog-title"
		aria-describedby="alert-dialog-description"
	>
		<DialogContent className={classes.contentModalRecibos}>
			<IconButton
				onClick={() => setModalRecibos({ openModalRecibos: false })}
				style={{
					color: "#FF6B0B",
					position: "fixed",
					marginTop: "-30px",
					marginLeft: "690px",
					backgroundColor: "#FEFEFE",
					border: "1px solid #A3AAB6",
					height: "36px",
					width: "36px",
				}}
			>
				<CloseOutlinedIcon
					style={{ width: "22px", height: "22px" }}
				></CloseOutlinedIcon>
			</IconButton>
			<p className="pTitleModalCvv"> Descarga de recibos</p>
			<p className="pModalRecibos">Descarga los documentos que requieras.</p>
			{showLinkDescarga(
				descargaRecibos.archivoXML,
				setArchivoVacio,
				"xml",
				"ComprobanteFiscal.xml",
				classes.margingIcon,
				"XML del CFDI"
			)}
			{showLinkDescarga(
				descargaRecibos.archivoPDF,
				setArchivoVacio,
				"pdf",
				"ComprobanteFiscal.pdf",
				classes.margingIcon,
				"PDF del CFDI"
			)}
			{showLinkDescarga(
				descargaRecibos.pdfComprobante,
				setArchivoVacio,
				"pdf",
				"comprobantePago.pdf",
				classes.margingIcon,
				"Comprobante de pago"
			)}
		</DialogContent>
		<DialogActions className={classes.footerModalRecibos}>
			<p className="marginLinkRecibos">
				<a
					className="hooverLinkRecibosFooter"
					onClick={() =>
						handleDescargaArchivos(descargaRecibos, setArchivoVacio)
					}
				>
					<button className="buttonIconRecibos">
						<GetAppOutlinedIcon
							className={classes.margingIcon}
						></GetAppOutlinedIcon>
					</button>
		Descargar todos los formatos
				</a>
			</p>
		</DialogActions>
	</Dialog>;
};

const setFormCfdiWithValues = (item, responseFiscales, dispatch) => {
	dispatch(
		action.setDatosEmitirCfdi({
			datosFiscales: {
				estatusCfdi: item.estatusCfdi,
				idPago: item.idPago,
				isMoral: responseFiscales.isMoral,
				nombreRazon: validValue(responseFiscales.nombreRazon, cadenaVacia),
				apellidoPaterno: validValue(
					responseFiscales.apellidoPaterno,
					cadenaVacia
				),
				apellidoMaterno: validValue(
					responseFiscales.apellidoMaterno,
					cadenaVacia
				),
				rfc: validValue(responseFiscales.rfc, cadenaVacia),
				domicilio: { ...responseFiscales.domicilio },
			},
			datosTramite: {
				numeroPoliza: item.numeroPoliza,
				numeroSiniestro: item.numeroSiniestro,
				marcaVehiculo: item.vehiculo.marcaVehiculo,
				tipoVehiculo: item.vehiculo.tipoVehiculo,
				modelo: item.vehiculo.modelo,
				placas: item.vehiculo.placas,
				concepto: "Deducible",
				monto: item.importe,
				metodoPago: "Tarjeta",
				numeroTarjeta: item.numeroTarjeta,
			},
		})
	);
	dispatch(action.setCfdi("Emitir"));
};

const setFormCfdi = (item, dispatch) => {
	dispatch(
		action.setDatosEmitirCfdi({
			datosFiscales: {
				idPago: item.idPago,
				isMoral: false,
				nombreRazon: cadenaVacia,
				apellidoPaterno: cadenaVacia,
				apellidoMaterno: cadenaVacia,
				rfc: cadenaVacia,
				domicilio: {
					calle: cadenaVacia,
					numero: cadenaVacia,
					interior: cadenaVacia,
					colonia: cadenaVacia,
					codigoPostal: cadenaVacia,
					delegacionMunicipio: cadenaVacia,
					ciudad: cadenaVacia,
					estado: cadenaVacia,
					telefono: cadenaVacia,
					correoElectronico: cadenaVacia,
				},
			},
			datosTramite: {
				numeroPoliza: item.numeroPoliza,
				numeroSiniestro: item.numeroSiniestro,
				marcaVehiculo: item.vehiculo.marcaVehiculo,
				modelo: item.vehiculo.modelo,
				placas: item.vehiculo.placas,
				concepto: "Deducible",
				monto: item.importe,
				metodoPago: "Tarjeta",
				numeroTarjeta: item.numeroTarjeta,
			},
		})
	);
	dispatch(action.setCfdi("Emitir"));
};

const cabeceraTabla = (
	<thead>
		<tr>
			<th style={{ width: "15%" }}>Póliza</th>
			<th style={{ width: "11%" }}>Siniestro</th>
			<th style={{ width: "25%" }}>Emitido a </th>
			<th style={{ width: "13%" }}>RFC</th>
			<th style={{ width: "13%" }}>Monto</th>
			<th style={{ width: "13%" }}>Estatus</th>
			<th style={{ width: "16%" }}>Acciones</th>
		</tr>
	</thead>
);

const tableSiniestros = (dataJsxTable) =>{
	const {viewResponsive,listaCfdi,classes,busqueda,inputBusqueda,listaFiltro,paginator, handleChangeSelect, 
		handleChangeInputEvent, submitBusqueda,handleSolicitarCfdi, handleDescargaRecibosWeb, setPaginator, handleDescargaRecibos} = dataJsxTable;
	return responsiveAndData(viewResponsive, listaCfdi) ? (
		<div>
			{showGridFormBusqueda(
				{ viewResponsive, listaCfdi, classes, busqueda, inputBusqueda },
				handleChangeSelect,
				handleChangeInputEvent,
				submitBusqueda
			)}
			<table className="table mt-20 mb-20 tabla-seguimiento-siniestro">
				{cabeceraTabla}
				<tbody>
					{listaFiltro.length > 0 && listaFiltro
						.slice(paginator.currentPage * paginator.numRegistros, paginator.currentPage * paginator.numRegistros + paginator.numRegistros)
						.map((item, i) => (
							<tr key={i} className="siniestro-color-N">
								<td>{item.numeroPoliza}</td>
								<td>{item.numeroSiniestro}</td>
								<td>{item.nombreRazon} {item.apellidoPaterno}{espacio}{item.apellidoMaterno}</td>
								<td style={{ textTransform: "uppercase" }}>{item.rfc}</td>
								<td>
				${espacio}
									{parseFloat(item.importe).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
								</td>
								<td>
									<div className="siniestro-status-container">
										<div>{item.estatusCfdi}</div>
									</div>
								</td>
								<td className="tdHoverAcciones">
									{showButtonPagar(item, handleSolicitarCfdi, classes.colorIconSize)}
									{validExistArchivos(item) && item.estatusCfdi === sinSolicitud ? (
										<button
											className="hoverAcciones buttonPagar tool-tip-descarga"
											style={{ borderRadius: "0px 4px 4px 0px" }}
											onClick={(e) => handleDescargaRecibosWeb(e, item)}
										>
											<a data-tooltip-naranja="Descargar recibos">
												<GetAppOutlinedIcon className={classes.colorIconSize}></GetAppOutlinedIcon>
											</a>
										</button>
									) : validExistArchivos(item) && item.estatusCfdi !== sinSolicitud  && (
										<button
											className="hoverAcciones buttonPagar tool-tip-descarga"
											style={{borderRadius: "4px 4px 4px 4px", marginLeft: "48px",}}
											onClick={(e) => handleDescargaRecibosWeb(e, item)}
										>
											<a data-tooltip-naranja="Descargar recibos">
												<GetAppOutlinedIcon className={classes.colorIconSize}></GetAppOutlinedIcon>
											</a>
										</button>
									)}
								</td>
							</tr>
						))}
				</tbody>
				<tfoot>
					<tr>
						<td colSpan="7">
							<div className="siniestro-paginator">
								{paginator.currentPage * paginator.numRegistros + 1} -{espacio}
								{getNumRegistro(listaFiltro.length, paginator)} de{espacio}
								{listaFiltro.length}
								<a
									className={validCurrentPage(paginator.currentPage)}
									onClick={() =>
										goToPage(
											paginator.currentPage - 1,
											paginator,
											listaFiltro,
											setPaginator
										)
									}
								>
									<img src={require("../../img/flecha-izquierda.svg")} />
								</a>
								<a
									className={validCurrentPageByFiltro(
										listaFiltro.length,
										paginator
									)}
									onClick={() =>
										goToPage(
											paginator.currentPage + 1,
											paginator,
											listaFiltro,
											setPaginator
										)
									}
								>
									<img src={require("../../img/flecha-abajo.svg")} />
								</a>
							</div>
						</td>
					</tr>
				</tfoot>
			</table>
		</div>
	) : (
		viewResponsive.responsive &&
listaCfdi.length > 0 && (
			<div>
				{showGridFormBusqueda(
					{ viewResponsive, listaCfdi, classes, busqueda, inputBusqueda },
					handleChangeSelect,
					handleChangeInputEvent,
					submitBusqueda
				)}
				<Grid container spacing={2} item xs={12} sm={12} md={12} lg={12}>
					{listaFiltro.map((element, i) => (
						<Grid item key={i} xs={12} sm={6} md={6} lg={6}>
							<Card className={classes.cardResponsive}>
								<div
									className="dropdown"
									style={{ float: "right", marginTop: "-16px" }}
								>
									<button
										className="dropbtn"
										style={{ border: "0px", backgroundColor: "#FFFFFF" }}
										onClick={(e) => myFunction(e, i)}
									>
										<MoreVertIcon
											style={{
												color: "#FF6B0B",
												width: "24px",
												height: "24px",
											}}
										></MoreVertIcon>
									</button>
									<div id={`drop${i}`} className="dropdown-content">
										{validExistArchivos(element) && (
											<a
												className="itemMenuResponsive"
												onClick={(e) =>
													handleDescargaRecibos(e, element, i)
												}
											>
					Descargar recibos
											</a>
										)}
										{element.estatusCfdi === sinSolicitud && (
											<a
												className="itemMenuResponsive"
												onClick={(e) => handleSolicitarCfdi(e, element)}
											>
					Solicitar CFDI
											</a>
										)}
									</div>
								</div>
								<p className="polizaCardResponsive">No. Poliza:&nbsp;</p>
								<p className="polizaCardResponsive">
									{element.numeroPoliza}
								</p>
								<div>
									<p className="siniestroCardResponsive">
				Siniestro:&nbsp;
									</p>
									<p className="siniestroCardResponsive">
										<strong>{element.numeroSiniestro}</strong>
									</p>
								</div>
								<p className="tDetalleCardResponsive">Emitido a: </p>
								<p className="tInfoCardResponsive">
									{element.nombreRazon} {element.apellidoPaterno}{espacio}
									{element.apellidoMaterno}
								</p>
								<p className="tDetalleCardResponsive">RFC</p>
								<p className="tInfoCardResponsive">{element.rfc}</p>
								<p className="tDetalleCardResponsive">Monto</p>
								<p className="tInfoCardResponsive">${espacio}
									{parseFloat(element.importe).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
								</p>
								<p className="estatusCardResponsive">
									<FiberManualRecordIcon
										style={{
											color: `${colorEstatus(element.estatusCfdi)}`,
											marginRight: "8px",
											width: "8px",
											height: "8px",
										}}
									></FiberManualRecordIcon>
									{element.estatusCfdi}
								</p>
							</Card>
						</Grid>
					))}
				</Grid>
			</div>
		)
	);
};

const ConsultaCfdi = (props) => {
	const numCliente = useSelector((state) => state.global.clienteUnico);
	const tokID = useSelector((state) => state.global.tid);
	const dispatch = useDispatch();
	const classes = useStyles();

	useEffect(() => {
		dispatch(action.onLoading(true));
		validWindowSize(setViewResponsive);
		window.scrollTo(0, 0);
		dispatch(action.getConsultaCfdi(numCliente, tokID))
			.then((response) => {
				setListaFiltro([...response.data]);
				setListaCfdi([...response.data]);
				dispatch(action.onLoading(false));
			})
			.catch((error) => {
				console.error(error);
				dispatch(action.onLoading(false));
			});
	}, [props]);
	const [archivoVacio, setArchivoVacio] = useState(false);
	const [viewResponsive, setViewResponsive] = useState({
		responsive: false,
	});
	const [paginator, setPaginator] = useState({
		currentPage: 0,
		numRegistros: 5,
		noHided: 0,
	});
	const [descargaRecibos, setDescargaRecibos] = useState({
		archivoPDF: cadenaVacia,
		archivoXML: cadenaVacia,
		pdfComprobante: cadenaVacia,
	});
	const [modalRecibos, setModalRecibos] = useState({
		openModalRecibos: false,
	});
	const [modalErrorG, setModalErrorG] = useState({
		openModalErrorG: false,
	});
	const [busqueda, setBusquedaSelect] = useState("numeroPoliza");
	const [inputBusqueda, setBusquedaInput] = useState(cadenaVacia);
	const [listaFiltro, setListaFiltro] = useState([]);
	const [listaCfdi, setListaCfdi] = useState([]);


	const handleChangeSelect = (event) => {
		setBusquedaSelect(event.target.value);
	};

	const handleChangeInputEvent = (event) => {
		handleChangeInput(event, listaCfdi, paginator, setListaFiltro, setBusquedaInput, setPaginator);
	};

	const handleSolicitarCfdi = (event, item) => {
		event.stopPropagation();
		dispatch(action.onLoading(true));
		dispatch(action.getFiscalesCfdi(item.numeroPoliza, tokID))
			.then((response) => {
				const validResponse = validRespDatosFiscales(response);
				if (validResponse) {
					const responseFiscales = { ...response.data.datosFiscales };
					setFormCfdiWithValues(item, responseFiscales, dispatch);
				} else {
					setFormCfdi(item, dispatch);
				}
			})
			.catch((error) => {
				console.error(error);
				setFormCfdi(item, dispatch);
			});
	};

	const handleDescargaRecibos = (event, item, i) => {
		event.stopPropagation();
		myFunction(event, i);
		setModalRecibos({
			openModalRecibos: true,
		});
		setRecibosDescarga(item, descargaRecibos, setDescargaRecibos);
	};

	const handleDescargaRecibosWeb = (e, item) => {
		e.stopPropagation();
		setModalRecibos({ openModalRecibos: true, });
		setRecibosDescarga(item, descargaRecibos, setDescargaRecibos);
	};

	const handleCloseModalRecibos = () => {
		setModalRecibos({
			openModalRecibos: false,
		});
	};

	const submitBusqueda = () => {
		filterRows();
	};

	const filterRows = () => {
		let temp = [];
		temp = listaCfdi.filter((filtro) => {
			return filtro[busqueda].includes(inputBusqueda);
		});
		setListaFiltro([...temp]);
		setPaginator({...paginator, currentPage: 0, numRegistros: 5, noHided: 0, });
	};

	const handlePrueba = () => {
		setModalErrorG({
			openModalErrorG: false,
		});
	};

	const handleCloseArchivoVacio = () => {
		setArchivoVacio(false);
	};
	const dataJsxTable = {viewResponsive, listaCfdi,classes ,busqueda, inputBusqueda, listaFiltro, paginator, 
		handleChangeSelect, handleChangeInputEvent, submitBusqueda,handleSolicitarCfdi, handleDescargaRecibosWeb, setPaginator, handleDescargaRecibos};

	return (
		<div className="container gnp-consulta-cfdi">
			{tableSiniestros(dataJsxTable)}
			{listaCfdi.length <= 0 && (
				<div className="no-cfdi-container">
					<div>
						<span>No hay algún reporte de CFDI.</span>
					</div>
					<img src={require("./no-siniestros.svg")} />
				</div>
			)}
			{modalRecibos.openModalRecibos && modalDescargaRecibos(classes, modalRecibos, descargaRecibos, handleCloseModalRecibos, setModalRecibos, setArchivoVacio )}
			{modalErrorPrueba(modalErrorG.openModalErrorG, handlePrueba)}
			{modalArchivoVacio(archivoVacio, handleCloseArchivoVacio)}
		</div>
	);
};

export default ConsultaCfdi;


// WEBPACK FOOTER //
// ./src/pago-deducible-auto/consulta-cfdi/consultaCfdi.cmpt.js